import { isScrMicromolUnit } from './clinicalUnits';

export const BACKEND_DERIVATION_TARGET_KEYS = ['egfr', 'crcl', 'age_pma', 'age_years', 'bmi', 'bsa'];

function toNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function isMissing(value: unknown): boolean {
  return value === null || value === undefined || value === '';
}

export function getMissingBackendDerivationTargets(
  values: Record<string, unknown>,
  targetKeys: string[] = BACKEND_DERIVATION_TARGET_KEYS,
): string[] {
  const hasSourceValue = Object.entries(values || {})
    .some(([key, value]) => !targetKeys.includes(key) && !isMissing(value));
  return hasSourceValue ? targetKeys : [];
}

export function mergeBackendDerivedValues(
  values: Record<string, unknown>,
  derivedValues: Record<string, unknown>,
): Record<string, unknown> {
  const next: Record<string, unknown> = { ...(values || {}) };
  Object.entries(derivedValues || {}).forEach(([key, value]) => {
    if (!isMissing(value)) {
      next[key] = value;
    }
  });
  return next;
}

export function normalizeScrMgDl(scr: unknown, scrUnit?: unknown): number | null {
  const numeric = toNumber(scr);
  if (numeric === null) return null;
  if (isScrMicromolUnit(String(scrUnit ?? ''))) return Number((numeric / 88.4).toFixed(6));
  if (numeric > 15) return Number((numeric / 88.4).toFixed(6));
  return numeric;
}
